<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn
        @click.stop="dialog = true"
        text
        rounded
        class="ma-3"
        color="green darken-3"
        >Sign Up</v-btn
      >
    </template>
    <v-card
      class="ma-auto pa-2"
      flat
      filled
      style="
          border-radius: 26px;
          border: 1px solid #18CAE6;
          max-width: 600px;
        "
    >
      <v-card-title>
        <span>SIGN</span><span class="red--text">UP</span> :THIRD PARTY
        <span class="red--text" v-if="thirdPartyType">
          - {{ thirdPartyType.toUpperCase() }}</span
        >
      </v-card-title>
      <v-form class="ma-2 pa-2" @submit.prevent="onSignUp">
        <v-expand-transition>
          <div>
            <v-select
              clearable
              required
              dense
              class="ma-2"
              outlined
              autofocus
              label="WHAT TYPE OF SERVICES DO YOU PROVIDE?"
              chips
              :items="types"
              v-model="thirdPartyType"
            >
            </v-select>
            <v-text-field
              label="FULL NAME"
              name="fullName"
              validate-on-blur
              required
              id="fullName"
              class="ma-2"
              outlined
              v-model="fullName"
              clearable
              dense
            ></v-text-field>
            <!-- EMAIL  -->
            <v-text-field
              label="EMAIL"
              name="email"
              validate-on-blur
              required
              id="email"
              class="ma-2"
              outlined
              v-model="email"
              clearable
              :rules="[rules.email]"
              type="email"
              dense
            ></v-text-field>
            <!-- PASSWORD  -->
            <v-text-field
              label="PASSWORD"
              name="password"
              validate-on-blur
              required
              id="password"
              class="ma-2"
              outlined
              v-model="password"
              clearable
              type="password"
              :rules="[rules.length(6)]"
              counter="6"
              dense
            ></v-text-field>
            <!-- CONFIRM PASSWORD  -->
            <v-text-field
              label="CONFIRM PASSWORD"
              name="confirmPassword"
              validate-on-blur
              required
              id="confirmPassWord"
              class="ma-2"
              outlined
              v-model="confirmPassword"
              clearable
              type="password"
              :rules="[rules.length(6)]"
              counter="6"
              dense
            ></v-text-field>

            <!-- PHONE  -->
            <v-text-field
              label="PHONE"
              name="phonE"
              validate-on-blur
              required
              id="phone"
              class="ma-2"
              outlined
              v-model="phone"
              v-mask="mask"
              clearable
              type="tel"
              dense
            ></v-text-field>
            <v-text-field
              label="FAX"
              name="fax"
              validate-on-blur
              required
              id="fax"
              class="ma-2"
              outlined
              v-model="fax"
              v-mask="mask"
              clearable
              type="tel"
              dense
            ></v-text-field>
            <!-- <v-card-title class="font-weight-light">
                          YOUR
                          <span class="red--text">.</span>FIRM
                        </v-card-title>-->
            <!-- FIRM NAME -->
            <v-text-field
              label="FIRM NAME"
              name="fullName"
              validate-on-blur
              required
              id="firmName"
              class="ma-2"
              outlined
              v-model="firmName"
              clearable
              dense
            ></v-text-field>

            <!-- FIRM ADDRESS LINE 1 -->
            <v-text-field
              label="FIRM STREET ADDRESS"
              name="firmAddressLine"
              validate-on-blur
              required
              id="firmAddressLine"
              class="ma-2"
              outlined
              v-model="firmAddressLine"
              clearable
              dense
            ></v-text-field>
            <v-text-field
              label="FIRM CITY, STATE, ZIP"
              name="firmCityStateZip"
              validate-on-blur
              required
              id="firmCityStateZip"
              class="ma-2"
              outlined
              v-model="firmCityStateZip"
              clearable
              dense
            ></v-text-field>

            <v-checkbox v-model="agreement" color="light-green accent-1">
              <template slot="label">
                I agree to the&nbsp;
                <a href="#" @click.stop.prevent="legalDialog = true"
                  >Terms of Service</a
                >
                &nbsp;and&nbsp;
                <a href="#" @click.stop.prevent="legalDialog = true"
                  >Privacy Policy</a
                >*
              </template>
            </v-checkbox>
            <v-dialog v-model="legalDialog" absolute max-width="400" persistent>
              <v-card>
                <v-card-title class="headline grey lighten-3"
                  >Legal</v-card-title
                >
                <v-card-text>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn text @click="(agreement = false), (dialog = false)"
                    >No</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    class="white--text"
                    color="light-green accent-1 accent-4"
                    @click="(agreement = true), (dialog = false)"
                    >Yes</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- </v-card> -->
          </div>
        </v-expand-transition>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mask } from "vue-the-mask";
// import * as moment from "moment";
// import slugify from "slugify";
export default {
  directives: { mask },
  data: () => ({
    dialog: false,
    email: "",
    password: "",
    confirmPassword: "",
    fullName: "",
    phone: "",
    fax: "",
    firmName: "",
    firmAddressLine: "",
    firmCityStateZip: "",
    agreement: false,
    mask: "(###) ###-####",
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      length: len => v =>
        (v || "").length >= len || `Invalid character length, required ${len}`
    },
    types: [
      "Public Adjuster",
      "Insurance Company",
      "Expert Witness",
      "Court Videographer",
      "Printing/Reprographics",
      "Process Server",
      "Private Investigator",
      "Supplemental Staff",
      "Paralegal",
      "Stenographer/Court Reporter",
      "Law Firm",
      "Accounting Firm",
      "Other"
    ],
    thirdPartyType: null,
    legalDialog: false
  }),
  methods: {
    closeDialog() {
      this.dialog = false;
    }
  },
  watch: {
    thirdPartyType(val) {
      console.log(val);
    }
  },
  created() {}
};
</script>

<style></style>
